import gql from "graphql-tag";

export const CLONER_EMPLOI = gql`
  mutation clonerEmploi($id: Int, $tgt_annee: String) {
    clonerEmploi(id: $id, tgt_annee: $tgt_annee) {
      success
      message
    }
  }
`;